export const EXAMPLE_FORM_VALIDATION_RULES = {
  textInput: {
    isRequiredTrim: {
      value: true,
    },
    maxLength: {
      value: 10,
    },
  },
  key: {
    isRequiredTrim: {
      value: true,
    },
    maxLength: {
      value: 3,
    },
  },
  textArea: {
    isRequiredTrim: {
      value: true,
    },
    maxLength: {
      value: 5,
    },
  },
  selectInput: {
    isRequiredTrim: {
      value: true,
    },
    maxLength: {
      value: 3,
    },
  },
  radioGroup: {
    isRequiredTrim: {
      value: true,
    },
  },
  checkboxGroup: {
    isRequiredTrim: {
      value: true,
    },
  },
  checkboxInput: {
    isRequiredTrim: {
      value: true,
    },
  },
  fileInput: {
    fileOfExtension: {
      value: [".png"],
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/example/ExampleFormValidationRules.js